import { makeStyles } from '@fluentui/react-components';
import React, { FC, useMemo } from 'react';
import { ExcelIcon } from './Svg/ExcelIcon';
import { OneNoteIcon } from './Svg/OneNoteIcon';
import { PdfIcon } from './Svg/PdfIcon';
import { PowerPointIcon } from './Svg/PowerPointIcon';
import { VisioIcon } from './Svg/VisioIcon';
import { WordIcon } from './Svg/WordIcon';
import { DocumentTextRegular, ImageRegular } from '@fluentui/react-icons';

interface Props {
    width?: number;
    height?: number;
    filename: string;
    notFoundExtension?: React.ReactNode;
}
interface RenderProps {
    width?: number;
    height?: number;
    fontSize?: number;
}
const extensionMapping: Record<string, FC<RenderProps>> = {
    bmp: ({ fontSize: fontsize }) => <ImageRegular fontSize={fontsize} />,
    doc: ({ width, height }) => <WordIcon height={height} width={width} />,
    docx: ({ width, height }) => <WordIcon height={height} width={width} />,
    dot: ({ width, height }) => <WordIcon height={height} width={width} />,
    dotx: ({ width, height }) => <WordIcon height={height} width={width} />,
    jpg: ({ fontSize: fontsize }) => <ImageRegular fontSize={fontsize} />,
    jpeg: ({ fontSize: fontsize }) => <ImageRegular fontSize={fontsize} />,
    one: ({ width, height }) => <OneNoteIcon height={height} width={width} />,
    pdf: ({ height }) => <PdfIcon height={height} />,
    png: ({ fontSize: fontsize }) => <ImageRegular fontSize={fontsize} />,
    pot: ({ width, height }) => <PowerPointIcon height={height} width={width} />,
    potx: ({ width, height }) => <PowerPointIcon height={height} width={width} />,
    ppt: ({ width, height }) => <PowerPointIcon height={height} width={width} />,
    pptx: ({ width, height }) => <PowerPointIcon height={height} width={width} />,
    vst: ({ width, height }) => <VisioIcon height={height} width={width} />,
    vstm: ({ width, height }) => <VisioIcon height={height} width={width} />,
    vstx: ({ width, height }) => <VisioIcon height={height} width={width} />,
    vsx: ({ width, height }) => <VisioIcon height={height} width={width} />,
    xls: ({ width, height }) => <ExcelIcon height={height} width={width} />,
    xlsx: ({ width, height }) => <ExcelIcon height={height} width={width} />,
    xlt: ({ width, height }) => <ExcelIcon height={height} width={width} />,
    xltx: ({ width, height }) => <ExcelIcon height={height} width={width} />,
};

const useStyles = makeStyles({
    root: {
        display: 'flex',
        justifyContent: 'center',
    },
});

export const FileTypeIcon: FC<Props> = ({ width, height, filename }) => {
    const defaultWidth = 24;
    const defaultHeight = 24;
    const defaultFontSize = 24;

    const extension = useMemo(() => {
        return filename.split('.').pop();
    }, [filename]);
    const classes = useStyles();
    const render = extensionMapping[extension ?? ''];

    return (
        <div className={classes.root} style={{ width, height }}>
            {
                render
                    ? render({ width: width ?? defaultWidth, height: height ?? defaultHeight, fontSize: defaultFontSize })
                    : <DocumentTextRegular fontSize={defaultFontSize} />
            }
        </div>
    );
};
